import React from 'react'
import type { BackdropProps as MuiBackdropProps } from '@material-ui/core/Backdrop'
import MuiBackdrop from '@material-ui/core/Backdrop'

function Backdrop(props: MuiBackdropProps) {
  return <MuiBackdrop {...props} />
}

export default Backdrop
